import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useQuery } from 'react-query';
import { motion } from 'framer-motion';
import ReactMarkdown from 'react-markdown';
import { api } from '../api';
import Breadcrumb from '../components/Breadcrumb';

const SectionPage = () => {
  const { slug } = useParams();
  const { data: sectionResponse, isLoading, error } = useQuery(
    ['section', slug],
    () => api.getSection(slug)
  );
  
  const section = sectionResponse?.data;

  // Scroll to top when component mounts (important for QR code access)
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-lodge-brown-600"></div>
      </div>
    );
  }

  if (error || !section) {
    return (
      <div className="text-center py-12">
        <h2 className="text-2xl font-display text-mountain-gray-700">Section not found</h2>
        <Link to="/" className="text-lodge-brown-600 hover:text-lodge-brown-700 mt-4 inline-block">
          ← Back to Home
        </Link>
      </div>
    );
  }

  const { title, content, category_name, category_slug } = section;

  // Build custom breadcrumb path for QR code access
  const customPath = category_name && category_slug ? [
    {
      name: category_name,
      path: `/category/${category_slug}`
    },
    {
      name: title,
      path: `/section/${slug}`
    }
  ] : null;

  return (
    <div className="max-w-4xl mx-auto">
      <Breadcrumb customPath={customPath} />
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <h1 className="text-3xl md:text-4xl font-display text-lodge-brown-800 mb-8">
          {title}
        </h1>

        <div className="bg-white rounded-xl shadow-md p-6 md:p-8">
          <div 
            className="prose prose-lg max-w-none content-styles"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>

        {/* Related sections or navigation buttons could go here */}
        <div className="mt-8 flex justify-between items-center">
          <Link
            to={category_slug ? `/category/${category_slug}` : '/'}
            className="text-lodge-brown-600 hover:text-lodge-brown-700 flex items-center"
          >
            ← Back to {category_name || 'Home'}
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default SectionPage;